export default "__VITE_ASSET__0f0be45d__"